// extracted by mini-css-extract-plugin
module.exports = {"error":"Input_error__SMvxK","disableArrows":"Input_disableArrows__a73Kf","icon":"Input_icon__BeCh2"};